module.exports = __webpack_public_path__ + "media/images/country_flags/mm-23f41e24dddfb0b8c95e2257daa617d8.png";